import { Field, Form, withFormik } from "formik";
import Box from "pages/_components/Box";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import { bool, func, shape } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { routerActions } from "react-router-redux/actions";
import { actions as loansActions, selectors as loansSelectors } from "reducers/loans";
import { actions as productsActions } from "reducers/products";
import { compose } from "redux";
import * as Yup from "yup";

const FORM_ID = "loans.details.alias";
class SetAlias extends Component {
    componentDidMount() {
        const { dispatch, ...rest } = this.props;
        dispatch(loansActions.readLoan(rest.match.params.id));
    }

    handleBack = () => {
        const { dispatch } = this.props;

        dispatch(routerActions.goBack());
    };

    render() {
        const { isSubmitting } = this.props;

        return (
            <>
                <Notification scopeToShow="loans/setAlias" />
                <Head onBack={this.handleBack} title="loans.alias.setAlias.title" />
                <MainContainer>
                    <Form className="above-the-fold full-height">
                        <Box fullHeight fullWidth display="flex" column>
                            <Box background="white" borderRadius="default" className="mt-5 p-5 pb-9 mx-n-5">
                                <Field
                                    component={TextField}
                                    hidePlaceholder
                                    idForm={FORM_ID}
                                    name="setAlias"
                                    type="text"
                                    labelNoMarginTop
                                    maxLength="28"
                                />
                            </Box>

                            <Button
                                type="submit"
                                className="mt-auto mb-7"
                                bsStyle="primary"
                                label="accounts.alias.setAlias.save"
                                loading={isSubmitting}
                                block
                            />
                        </Box>
                    </Form>
                </MainContainer>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    loan: loansSelectors.getSelectedLoan(state),
});

SetAlias.propTypes = {
    dispatch: func.isRequired,
    fetching: bool.isRequired,
    isSubmitting: bool.isRequired,
    match: shape().isRequired,
};

export default compose(
    connect(mapStateToProps),
    withFormik({
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: (props) => ({
            setAlias: props.loan ? props.loan.productAlias : "",
            productId: props.match.params.id,
        }),
        validationSchema: () =>
            Yup.object().shape({
                setAlias: Yup.string().nullable(),
            }),
        handleSubmit: ({ productId, setAlias }, formikBag) => {
            formikBag.props.dispatch(productsActions.changeProductAlias(setAlias, productId, true), formikBag);
        },
    }),
)(SetAlias);
